import Vue from 'vue'

const FILE_TYPE = 'file'
const LINK_TYPE = 'link'

export async function createFileObject (file, categoryId) {
    if (file instanceof Array) {
        file = file[0]
      }
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          let encoded = reader.result.toString().replace(/^data:(.*,)?/, '')
          if ((encoded.length % 4) > 0) {
            encoded += '='.repeat(4 - (encoded.length % 4))
          }
          resolve(encoded)
        }
        reader.onerror = error => reject(error)
      })
    return {
        base64: await toBase64(file),
        name: file.name,
        size: file.size,
        contentType: file.type,
        idFileTag: categoryId
      }
}
export function createLinkObject (link) {
    return {
        name: link.name,
        url: link.url,
        idFileTag: link.category.id
      }
}
export async function getFilesAndLinks (data) {
  return {
    files: await Promise.all(data.filter(file => file.data.fileType === FILE_TYPE && file.file instanceof File).map(file => createFileObject(file.file, file.data.category.id))),
    links: data.filter(file => file.data.fileType === LINK_TYPE).map(file => createLinkObject(file.data))
  }
}
export async function uploadFile (path, params, file, uploadToClinicHistory = false) {
    let categoryId = params ? params.idFileTag : null
    let fileObject = uploadToClinicHistory ? file : await createFileObject(file, categoryId)

    let promise = Vue.prototype.$api.post(path, {
        ...params,
        token: Vue.prototype.$apiToken,
        file: fileObject
    },
    {
      headers: {
        'Content-Type': uploadToClinicHistory ? 'multipart/form-data' : 'application/json;charset=utf-8'
      }
    })

    return promise
}


// WEBPACK FOOTER //
// ./src/helpers/file.helpers.js